import { useEffect, useState, useRef, } from "react"
import { getCombos, getIndicadorObjetivo, getObjetivoEspecifico, setIndicadorObjetivo, setPlantillaSencilla, updateIndicadorObjetivo } from '../componentes/api.js';
import { Alert, AlertTitle, Checkbox, Divider, FormGroup, FormControlLabel, TextField, Switch } from '@mui/material';
import BarraBotones from "../comun/BarraBotones.jsx";
import Table from 'react-bootstrap/Table';
import { FaFileMedical } from "react-icons/fa";
import VentanaCrear from '../comun/VentanaCrear.jsx'
import Poblacion from './Poblacion.jsx'


const IndicadorObjetivo =(props)=>{
  const testRef = useRef(null);
  const scrollToElement = () => testRef.current.scrollIntoView();
  const [boton, setBoton] = useState('');
  const [cant, setCant] = useState(0);
  const [actividades, setActividades] = useState([]);
  const [objetivo, setObjetivo] = useState('');
  const [indicadores, setIndicadores] = useState([]);
  const [datos, setDatos] = useState({
    id:'',
    idProyecto:props.idProyecto,
    idActividad: '',
    detalle:'',
    participantes:1,
    cantidad:1,
    porcentaje:0,
    registrado:false,
    culminado:false,
    idPoblacion:'',
    activo:true,
    idUsuario:props.idUsuario
  })


  /** Para el manejo de la ventana de creación de tipos de actividades **/
  const [mostrarCrear, setMostrarCrear] = useState(false);


  useEffect(() =>{
    cargarCombos({"Tabla":"actividades","Campo":""},"idActividad");
    setDatos({...datos, ['idProyecto']: props.idProyecto})
    cargarObjetivos(props.idProyecto)
    if(props.idProyecto !==''){
      cargarIndicadores()
      nuevo();
    }
    
  },[props.idProyecto]);

  const asignarDato =(event)=>{
    event.preventDefault();

    if(event.target.name==='participantes'){
      let por = (datos.cantidad * 100) / event.target.value
      setDatos({...datos, [event.target.name]: event.target.value, porcentaje: por })

    }else if(event.target.name==='cantidad'){
      let por = (event.target.value * 100) / datos.participantes
      setDatos({...datos, [event.target.name]: event.target.value, porcentaje: por })

    }else if(event.target.name==='porcentaje'){
      let cant = (datos.participantes * event.target.value) / 100
      setDatos({...datos, [event.target.name]: event.target.value, cantidad: cant })


    }else if(event.target.name==='registrado'){
        setDatos({...datos, [event.target.name]: event.target.checked})
          
    }else if(event.target.name==='culminado'){
        setDatos({...datos, [event.target.name]: event.target.checked})
        
    }else if(event.target.name==='activo'){
        setDatos({...datos, [event.target.name]: event.target.checked})
  
    }else{
      setDatos({...datos, [event.target.name]: event.target.value})
    }
  }

  const botones=(btn)=>{
    if(btn===0){ nuevo();
    }else if(btn===1){ validarDatos();
    }else if(btn===3){ exportar();
    }else if(btn===4){ nuevo();
    }
  }


  const cargarCombos = async(datos, cbo)=>{
    try {
      const response = await getCombos(datos)
      setActividades(response.data)
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al cargar los Combos", error])
    }
  }

  const cargarIndicadores=async()=>{
    try {
      /**** Carga los indicadores que están creados para el Objetivo Específico ***/
      const response = await getIndicadorObjetivo({idProyecto:props.idProyecto})
      setIndicadores(response.data);
      setCant(response.data.length)
             
     } catch (error) {
       props.mostrarMsg(["ERROR", "Ocurrio un error al cargar los Indicadores del Objetivo del Proyecto ", error])
     }
  }

  const cargarObjetivos=async(idProyecto)=>{
    try {
      /**** Carga el Objetivo específico del Proyecto ***/
      const response = await getObjetivoEspecifico(idProyecto)
      setObjetivo(response.data.ObjetivoEspecifico);

             
     } catch (error) {
       props.mostrarMsg(["ERROR", "Ocurrio un error al cargar el Objetivo del Proyecto ", error])
     }
  }
  
  const exportar =()=>{
    props.mostrarMsg(["OK, exportará los datos"])
  }

  const grabarRegistro = async()=>{
    try {
      const response = await setIndicadorObjetivo(datos)
      setDatos({...datos, ['id']:response.data.Id})
      setBoton('grabar');
      cargarIndicadores()
      props.mostrarMsg(["Felicidades!!!", "Se ha creado el Indicador para el Objetivo Específico del Proyecto"])
            
    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Grabar el aporte de la empresa al Proyecto ", error])
    }
  }


  const grabarCampo = async(nbre)=>{
    try {
      let plantilla ={
        tabla: "actividades",
        nbre: nbre,
        activo: "1",
        idUsuario: props.idUsuario
      }
      const response = await setPlantillaSencilla(plantilla)
      setDatos({...datos, idActividad: response.data.Id})
      cargarCombos({"Tabla":"actividades","Campo":""},"idActividad");
      

    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Grabar La Actividad", error])
    }
  }




  const modificarRegistro= async()=>{
    try {
      await updateIndicadorObjetivo(datos)
      setBoton('grabar');
      cargarIndicadores()
      props.mostrarMsg(["Indicador Modificado!"])
      

    } catch (error) {
      props.mostrarMsg(["ERROR", "Ocurrio un error al Modificar los Aportes del Proyecto", error])
    }
  }
  
  const mostrarRegistro = async(event, reg)=>{
    event.preventDefault();
    setDatos({...datos,
      id: reg.Id,
      idProyecto: props.idProyecto,
      detalle: reg.Detalle,
      participantes: reg.Participantes,
      cantidad: reg.Cantidad,
      porcentaje: reg.Porcentaje,
      registrado: reg.Registrados===0? false: true,
      culminado: reg.Culminados===0? false: true,
      idActividad: reg.IdActividad,
      idPoblacion: reg.IdPoblacion,
      activo: reg.Activo===0? false: true,
      idUsuario:props.idUsuario
    }) 
    scrollToElement()
    setBoton('buscar')
  }

  const mostrarVentanaCrear = (event)=>{
    event.preventDefault()
    setMostrarCrear(true)
  }

  const nuevo=()=>{
    setDatos({
      id:'',
      idProyecto:props.idProyecto,
      idActividad: '',
      detalle:'',
      participantes:1,
      cantidad:1,
      porcentaje:0,
      registrado:false,
      culminado:false,
      idPoblacion:'',
      activo:true,
      idUsuario:props.idUsuario
    })
    setBoton('nuevo')
  }


  const validarDatos = ()=>{
    if(props.idProyecto===''){
      props.mostrarMsg(["Por favor seleccione el Proyecto"])

    }else if(datos.detalle===''){
      props.mostrarMsg(["Por favor digite el Detalle del Indicador"])
    
    }else if(datos.cantidad < 1 && datos.procentaje < 1){
      props.mostrarMsg(["Por favor digite una Cantidad o Porcentaje para medición del Indicador"])
    
    }else if(datos.idActividad===''){
      props.mostrarMsg(["Por favor seleccione La Actividad asociada al Indicador"])
    
    }else{
      if(datos.id===''){
        grabarRegistro()
      }else{
        modificarRegistro()
      }
    }
  }

  return(
    <div className="container-fluid mt-3" ref={testRef}>
      <div className="row mt-3">
        <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
      </div>

      <div className="row card">
        <Alert severity="info"><AlertTitle>OBJETIVO ESPECIFICO</AlertTitle>{objetivo}</Alert>
      
        <div className="row mt-3 mb-3 m-1">
          <TextField
            autoFocus={true}
            name="detalle"
            label="Detalle del Indicador"
            className="form-control"
            type="text"
            multiline
            value={datos.detalle}
            onChange={asignarDato}
          />
        </div>

        <div className="row">
          <div className="col-sm-4">
            <TextField
              name="participantes"
              label="Cantidad de Participantes Requeridos"
              className="form-control"
              type="number"
              value={datos.participantes}
              onChange={asignarDato}
            />
          </div>

          <div className="col-sm-4">
            <TextField
              name="cantidad"
              label="Cantidad para Indicador #"
              className="form-control"
              type="number"
              value={datos.cantidad}
              onChange={asignarDato}
            />
          </div>

          <div className="col-sm-4">
            <TextField
              name="porcentaje"
              label="Cantidad Porcentual %"
              className="form-control"
              type="number"
              value={datos.porcentaje}
              onChange={asignarDato}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-sm-4">
            <FormControlLabel 
              checked={datos.registrado}
              name="registrado"
              control={<Checkbox />} 
              label="Participantes Registrados" 
              onChange={asignarDato}
            />
          </div>
        
          <div className="col-sm-4">
            <FormControlLabel 
              checked={datos.culminado}
              name="culminado"
              control={<Checkbox />} 
              label="Participantes Culminados" 
              onChange={asignarDato}
            />
          </div>
        </div>

        <div className="input-group form-floating mt-3 mb-3">
          <select 
            label="Actividad"
            name='idActividad' 
            className="form-select form-control" 
            id="idActividad" 
            aria-label="Actividad"
            value={datos.idActividad} 
            onChange={(event) => asignarDato(event)}
          >
            <option key='0' value='0'>Por favor seleccione una Actividad...</option>
            {actividades.map((reg) => {
              return (
                <option key={reg.Id} value={reg.Id} label={reg.Nbre}> {reg.Nbre} </option>
              );
            })}
          </select>
          <button 
            className="btn btn-primary" 
            type="button"
            onClick={(event) =>{ mostrarVentanaCrear(event)}}
          >
            <FaFileMedical />
          </button>
        </div>
      </div>

      <div className="row mt-3">
        <Poblacion 
          idProyecto={props.idProyecto} 
          Objetivo={datos.id} 
          Resultado={''} 
          UsuarioReg={props.idUsuario}
          boton={boton}
          setBoton={setBoton}
          mostrarMsg={props.mostrarMsg}/>
      </div>

      <div className="row card shadow mt-3">
        <FormGroup>
          <FormControlLabel 
            name="activo"
            control={
              <Switch
                checked={datos.activo}
                onChange={asignarDato}
                inputProps={{ 'aria-label': 'Activo' }} 
              />
            } 
              label={datos.activo===true ? "Estado: Objetivo ACTIVO" : "Estado: Objetivo ANULADO" }
              labelPlacement="start"
            />
        </FormGroup>
      </div>  

      <Divider component="ul" />
      <div className="row mt-3">
        <BarraBotones botones={botones} btnActivos={[true, true, false, true, true]}/>
      </div>
      <Divider component="ul" />

      <div className="row">
        <div className="row mt-2">
        <h3 className="mt-2 mb-2 text-muted">LISTADO DE INDICADORES - Cantidad: {cant}</h3>
          <Table className="table table-hover table-bordered" responsive>
            <thead className="table-primary">
              <tr>
                <th scope="col"># Item</th>
                <th scope="col">Acción</th>
                <th scope="col">Detalle</th>
                <th scope="col"># Participantes</th>
                <th scope="col">Cantidad Mínima</th>
                <th scope="col">Procentaje %</th>
                <th scope="col">Actividad Asociada</th>
                <th scope="col">Tipo de Poblacion</th>
                <th scope="col">Requiere Registrados</th>
                <th scope="col">Requiere Culminados</th>
                <th scope="col">Estado</th>
                
              </tr>
            </thead>
            <tbody>
            {indicadores.length > 0 && 
            indicadores.map((reg, i)=>{
              return(
              <tr  className={reg.Activo===0? "table-danger":""} key={i}>
                <th> {i + 1} </th>
                <th> <a href="#divTop">
                  <button 
                    className="btn btn-primary form-control"
                    onClick={(event) =>{mostrarRegistro(event, reg)}}
                  >Editar</button> 
                  </a>
                </th>
                <th> {reg.Detalle} </th>
                <th> {reg.Participantes} </th>
                <th> {reg.Cantidad} </th>
                <th> {reg.Porcentaje} </th>
                <th> {reg.NbreActividad} </th>
                <th> {reg.NbrePoblacion} </th>
                <th> {reg.Registrados===0 ? 'No':'Si'} </th>
                <th> {reg.Culminados===0 ? 'No':'Si'} </th>
                <th> {reg.Activo===0 ? 'Inactivo':'Activo'} </th>
                
              </tr>
              )
            })}
             
            </tbody>
          </Table>
        </div>
      </div>

      {mostrarCrear===true &&
        <VentanaCrear 
          titulo={'TIPO DE PROYECTO'} 
          grabarCampo={grabarCampo} 
          mostrarCrear={mostrarCrear}
          setMostrarCrear={setMostrarCrear}
        />
      }
      {/* </Form> */}
    </div>
  )
}

export default IndicadorObjetivo